<template>
  <v-dialog :value="value" v-on:input="$emit('input', $event)" persistent :max-width="!confirm ? '750' : '300'">
    <v-card v-show="!confirm">
      <v-card-title class="headline justify-center">
        <span>メンテナンス編集</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <!-- Title -->
        <label for="title">
          タイトル
          <span class="red--text">*</span>
        </label>
        <v-text-field dense outlined id="title" v-model="title" :error-messages="titleErrors" @input="$v.title.$touch()"
          @blur="$v.title.$touch()"></v-text-field>
        <label for="title">
          詳細
          <span class="red--text">*</span>
        </label>
        <v-textarea class="mt-2" dense outlined auto-grow v-model="content" :error-messages="contentErrors"
          @input="$v.content.$touch()" @blur="$v.content.$touch()"></v-textarea>
        <label for="title"> 日時 </label>
        <v-row no-gutters class="mt-2">
          <!-- Start date -->
          <DatePicker v-model="startDate" :error="dateTimeErrors" :disabled="now || itemUpdate.status == 'MAINTAIN'"
            :min="$moment(new Date()).format('YYYY-MM-DD HH:mm')" class="mr-5" />
          <!-- Start time -->
          <TimePicker v-model="startTime" :error="dateTimeErrors"
            :disabled="!startDate || now || itemUpdate.status == 'MAINTAIN'" :key="`start-time-${timePickerKey}`"
            :min="minStartTime" />
          <strong class="mt-2 mx-2">から</strong>
          <!-- End date -->
          <DatePicker v-model="endDate" :min="startDate" class="mr-5" :key="`end-date-${timePickerKey}`" />
          <!-- End time -->
          <TimePicker :min="minEndTime" class="mr-5" v-model="endTime" :disabled="!endDate || !startTime"
            :key="`end-time-${timePickerKey}`" />
          <strong class="mt-2 ml-1">まで</strong>
        </v-row>
        <v-row no-gutters>
          <span class="red--text">{{ dateTimeErrors }}</span>
        </v-row>
        <v-row no-gutters>
          <v-checkbox :disabled="now" label="即時メンテナンス"></v-checkbox>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleHiddenDialog">キャンセル</v-btn>
        <v-btn color="primary" class="font-weight-bold" @click="handleHideShowConfirm">決定</v-btn>
      </v-card-actions>
    </v-card>
    <!-- Dialog confirm -->
    <v-card v-show="confirm">
      <v-card-title class="headline justify-center">
        <span>確認</span>
      </v-card-title>
      <v-card-text class="pb-0">
        <p class="mb-0">メンテナンスモードの日時は</p>
        <strong class="mb-0">
          {{ `${startDate} ${startTime}` | dateTime }} ~
          <template v-if="endDate && endTime">
            {{ `${endDate} ${endTime}` | dateTime }}
          </template>
          <template v-else> 未定 </template>
        </strong>
        <p class="mb-0">に変更しますがよろしいでしょうか。</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="font-weight-bold" :loading="loadingUpdateMaintain" @click="updateMaintain" small>
          OK</v-btn>
        <v-btn @click="handleHideShowConfirm" small>キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
import DatePicker from "@/components/DatePicker/DatePicker";
import TimePicker from "@/components/TimePicker/TimePicker";
import { updateRecoveMaintain } from "@/api/MasterData.api";
import vm from "@/main";
export default {
  props: ["value", "itemUpdate", "data"],
  mixins: [mixin.ValidateMaintain],
  components: { DatePicker, TimePicker },
  data() {
    return {
      loadingUpdateMaintain: false,
      confirm: false,
      menuStartDate: false,
      title: "",
      content: "",
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      now: false,
      timePickerKey: 0,
      dateTimeErrors: "",
      totalUpdate: 0,
    };
  },
  computed: {
    minStartTime() {
      const { startDate, $moment } = this;
      if (startDate == $moment(new Date()).format("YYYY-MM-DD")) {
        return $moment(new Date()).add(5, "m").format("HH:mm");
      }
      return "";
    },
    minEndTime() {
      const { startDate, endDate, $moment } = this;
      var val;
      if (startDate == "" || endDate == "") {
        val = null;
      } else if (startDate == endDate) {
        val = $moment(new Date()).add(5, "m").format("HH:mm");
      }
      return val;
    },
  },
  filters: {
    statusMaintain: function (val) {
      let status =
        val == "MAINTAIN_END" ? "終了" : val == "BOOKING" ? "予約" : "実行中";
      return status;
    },
    dateTime: function (val) {
      const { $moment } = vm;
      if (!val) return "未定";
      return $moment(val).format("YYYY年MM月DD HH:mm");
    },
  },
  watch: {
    startDate: function (val) {
      console.log("this.totalUpdate: startDate", this.totalUpdate);
      if (this.totalUpdate != 0) {
        if (val == "") {
          this.startTime = "";
        }
        this.endDate = "";
        this.endTime = "";
      }
      this.totalUpdate++;
    },
    endDate: function (val) {
      console.log("this.totalUpdate: endDate", this.totalUpdate);
      console.log("val: ", val);
      if (this.totalUpdate != 0) {
        if (val == "") {
          this.endTime = "";
          this.timePickerKey++;
        }
      }
      this.totalUpdate++;
    },
    startTime: function () {
      console.log("this.totalUpdate: startTime", this.totalUpdate);
      if (
        this.totalUpdate != 2 &&
        this.totalUpdate != 0 &&
        this.totalUpdate != 1
      ) {
        this.endTime = "";
        this.timePickerKey++;
      }
      this.totalUpdate++;
    },
    endTime: function () {
      this.timePickerKey++;
    },
    value: function (val) {
      if (val) {
        this.totalUpdate = 0;
        console.log("this.itemUpdate", this.itemUpdate);
        const { title, content, start_time, end_time } = this.itemUpdate;
        const { $moment } = this;
        this.title = title;
        this.content = content;
        this.now = false;
        if (end_time) {
          this.endDate = $moment.unix(end_time).format("YYYY-MM-DD");
          this.endTime = $moment.unix(end_time).format("HH:mm");
        } else {
          this.endDate = "";
          this.endTime = "";
        }
        if (start_time) {
          this.startDate = $moment.unix(start_time).format("YYYY-MM-DD");
          this.startTime = $moment.unix(start_time).format("HH:mm");
          const currentDate = $moment(new Date()).format('YYYY-MM-DD');
          const currentTime = $moment(new Date()).format('HH:mm');
          if (this.startDate == currentDate && currentTime >= this.startTime) {
            this.now = true;
          }
        } else {
          this.startDate = "";
          this.startTime = "";
        }
      }
    },
  },
  methods: {
    async updateMaintain() {
      const {
        startDate,
        startTime,
        endDate,
        endTime,
        title,
        content,
        now,
      } = this;
      this.loadingUpdateMaintain = true;

      let start_time;
      if (!startDate || !startTime) {
        start_time = "";
      } else {
        start_time = new Date(`${startDate} ${startTime}`).getTime() / 1000;
      }
      let end_time;
      if (!endDate || !endTime) {
        end_time = "";
      } else {
        end_time = new Date(`${endDate} ${endTime}`).getTime() / 1000;
      }
      let params = {
        ...this.itemUpdate,
        id: this.itemUpdate.Id,
        title,
        content,
        start_time,
        end_time,
        now,
      };
      await updateRecoveMaintain(params)
        .then(() => {
          this.$emit("resetList");
          this.$emit("input", false);
          this.confirm = !this.confirm;
        })
        .catch(
          ({
            response: {
              data: { result },
            },
          }) => {
            if (result.error == "UPDATE_SYSTEM_TIME_FAIL") {
              this.$toast.error(
                "開始時間を過ぎているため変更できません。"
              );
              this.$emit("resetList");
              this.$emit("input", false);
            }
            this.confirm = !this.confirm;
          }
        );
      this.loadingUpdateMaintain = false;
    },
    handleHideShowConfirm() {
      const { startDate, startTime } = this;
      this.$v.$touch();
      this.dateTimeErrors = this.checkDateTimeStart(this.now);
      if (!this.$v.$anyError && !this.dateTimeErrors) {
        if (
          new Date(`${startDate} ${startTime}`).getTime() <=
          new Date().getTime() &&
          this.itemUpdate.status !== "MAINTAIN" && this.now !== true
        ) {
          return this.$toast.error(
            "開始時間を過ぎているため変更できません。"
          );
        }
        this.confirm = !this.confirm;
      }
    },
    checkDateTimeStart(now) {
      const { startDate, startTime } = this;
      let start_Time = new Date(`${startDate} ${startTime}`).getTime();
      let time = new Date().getTime();
      if (now) return "";
      if (startDate == "" || startTime == "") {
        return "開始日時を選択してください。";
      } else if (start_Time < time && this.itemUpdate.status !== "MAINTAIN") {
        return "過去の時間が登録できません。";
      }
      return "";
    },
    handleHiddenDialog() {
      this.$v.$reset();
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  min-width: 130px;
  margin-top: 10px;
  font-weight: bold;
}
</style>